<template>
  <div class="modal-global">
    <div class="modal-global__modal">
      <!-- <header class="modal-global__modal__top">
        <h1 class="modal-global__modal__top__title">
          <slot name="title"></slot>
        </h1>
      </header> -->

      <article class="modal-global__modal__body">
        <pre class="modal-global__modal__body__desc">
          <slot name="description"></slot>
        </pre>
      </article>

      <footer class="modal-global__modal__footer">
        <button
          v-if="!props.isShowCancel"
          @click.stop="$emit('onCancel')"
          class="px-8 py-3 mr-8 cs-btn cs-btn-clear"
        >
          취소
        </button>
        <button @click.stop="$emit('onConfirm')" class="px-8 py-3 cs-btn cs-btn-clear">
          <span class="text-second">확인</span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  isShowCancel: {
    type: Boolean,
    default: true,
  },
});
</script>
